export default __webpack_public_path__ + "static/media/short-arrow-icon.848831d5.svg";